import { Box, } from "@bracket/ui/nodes";
import { getTheme, } from "@bracket/ui/themes";
import styled, { css, keyframes, } from "styled-components";
import type { ColorDeclaration, ThemePalette, } from "@bracket/ui/types";


export declare type LoaderType = "ellipsis";



export declare type LoaderProps = {
	style?: React.CSSProperties;
	type?: LoaderType;
	scheme?: "light" | "dark";
	color?: ColorDeclaration | keyof ThemePalette;
	backgroundColor?: string;
	center?: boolean;
	flex?: boolean;
	height?: string;
	small?: boolean;
	className?: string;
	scale?: number;
}



export const Loader: React.FC<LoaderProps> = ({
	type = "ellipsis",
	style = {},
	scheme,
	color,
	backgroundColor,
	center = false,
	flex = true,
	height,
	small,
	className,
	scale,
}) => {
	return (
		<Brace
			className={`loader-brace${className ? ` ${className}` : ""}`}
			style={style}
			$color={color}
			$backgroundColor={backgroundColor}
			$scheme={scheme}
			$center={center}
			$flex={flex}
			$height={height}
			$scale={scale ? scale : small ? 0.5 : undefined}
		>
			<LoadedContainer className="loader-container" $center={center}>
				{ [ 1, 2, 3, 4, ].map(i => <Dot key={i} $index={i} /> ) }
			</LoadedContainer>
		</Brace>
	);
};


const Brace = styled(Box)<{
	$color?: ColorDeclaration | keyof ThemePalette;
	$scheme?: "light" | "dark";
	$backgroundColor?: string;
	$center?: boolean;
	$flex?: boolean;
	$height?: string;
	$scale?: number;
}>`
	align-items: center;
	justify-content: center;
	width: ${({ $flex }) => $flex ? "100%" : "auto"};
	height: ${({ $height }) => $height || "80px"};
	color: ${({ $color, }) => getTheme().primary_on };
	background-color: ${({ $backgroundColor, }) => "transparent"};
	scale: ${({ $scale }) => $scale || undefined};
	min-height: ${({ $height }) => $height || undefined};
`;


const LoadedContainer = styled(Box)<{ 
	$center?: boolean; 
	$color?: ColorDeclaration | keyof ThemePalette;
}>`
	position: relative;
	align-items: center;
	justify-content: center;
	color: ${({ $color, }) => getTheme().surface_on };
	width: 80px;
	height: 13px;
`;


const Dot = styled(Box)<{ $index: number; }>`
	position: absolute;
	width: 13.33333px;
	height: 13.33333px;
	border-radius: 50%;
	background: currentColor;
	// animation-timing-function: cubic-bezier(0, 1, 1, 0);

	${({ $index }) => {
		if ($index === 1)
			return css`
				left: 8px;
				animation: ${ldsEllipsis1} 0.6s infinite;
			`;
		if ($index === 2)
			return css`
				left: 8px;
				animation: ${ldsEllipsis2} 0.6s infinite;
			`;
		if ($index === 3)
			return css`
				left: 32px;
				animation: ${ldsEllipsis2} 0.6s infinite;
			`;
		if ($index === 4)
			return css`
				left: 56px;
				animation: ${ldsEllipsis3} 0.6s infinite;
			`;
	}}
`;

const ldsEllipsis1 = keyframes`
	0%		{ transform: scale(0); }
	100%	{ transform: scale(1); }
`;

const ldsEllipsis2 = keyframes`
	0%		{ transform: translate(0, 0); }
	100%	{ transform: translate(24px, 0); }
`;

const ldsEllipsis3 = keyframes`
	0%		{ transform: scale(1); }
	100%	{ transform: scale(0); }
`;
